module.exports = __webpack_public_path__ + "img/asiento.f59cdb69.png";